<template>
  <div class="preview-link-wrapper" v-if="preview_mode == true">
    <a @click="closePreview(path_params, link_to_test)" v-tooltip="{location: 'top'}" data-title="This link will only display in Preview Mode.">
      <i class="icon pencil-red"></i>
      <slot></slot>
    </a>
  </div>
</template>

<script>
import {computed, defineComponent} from 'vue';
import store from "@/store";

import global_methods from "@/utils/globalFunctions";

export default defineComponent({
  name: 'PreviewEditLink',
  components: {},
  props: {
    path_params: {
      type: String,
      default: '',
    },
    link_to_test:{
      type: Boolean,
      default: false,
      required: false
    }
  },
  setup() {

    const preview_mode = computed(() => {
      return store.getters.previewMode
    });

    const closePreview = global_methods.closePreview;

    return {preview_mode, closePreview};
  },


});
</script>

<style lang="scss" scoped>
.preview-link-wrapper {
  display: inline-flex;

  a {
    cursor: pointer;
    display: flex;
    gap: 8px;
    align-items: center;
    margin-top: 12px;

    text-decoration: none;
  }
}
</style>